<template>
<div>
<div class="container fluid" v-if="user.authenticated && !message">
<div class="row">
  <div class="col">
    <h4 class="achHeading">CREDIT CARD AUTHORIZATION</h4>
    <p class="achParagraph">All fields of this form must be completed before submitting.</p>
  </div>
</div>
<div class="row">
  <div class="col">
    <h4>Contract #: {{parentData}}</h4>
  </div>
</div>
<b-form @submit.prevent="validateBeforeSubmit" autocomplete="off">
<div class="row">
  <div class="col">
      <label class="label">Customer Name</label>
      <p class="control has-icon has-icon-right">
        <b-input name="Lessee Name" v-model="ccInfo.Lessee" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Lessee Name') }" type="text"/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Lessee Name')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Lessee Name')" class="help is-danger">{{ errors.first('Lessee Name') }}</span>
      </p>
  </div>
  <div class="col">
      <label class="label">Phone Number</label>
      <p class="control has-icon has-icon-right">
        <masked-input name="Phone Number" v-model="ccInfo.LesseePhoneNumber" v-validate="'required'" mask="(111) 111-1111" :class="{'form-control input': true, 'is-danger': errors.has('Phone Number') }" type="text"/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Phone Number')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Phone Number')" class="help is-danger">{{ errors.first('Phone Number') }}</span>
      </p>
  </div>
</div>
<div class="row">
    <div class="col">
      <p class="achParagraph">I (we) hereby authorize Pawnee Leasing Corporation (Lessor or Lender) to initiate debit entries and to initiate, if necessary, credit entries and adjustments for any debit entries in error to the credit card indicated below on the due date of the payment.
        </p>
    </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label class="label">Credit Card Type</label>
    <p class="control has-icon has-icon-right">
      <b-form-select name="Credit Card Type" v-model="ccInfo.CCType" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Credit Card Type') }">
        <option value="visa">Visa</option>
        <option value="master">Mastercard</option>
        <option value="amex">American Express</option>
        <option value="discovery">Discovery</option>
        </b-form-select>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Credit Card Type')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Credit Card Type')" class="help is-danger">{{ errors.first('Credit Card Type') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label class="label">Name on Credit Card:</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Name on Card" v-model="ccInfo.CCName" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Name on Card') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Name on Card')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Name on Card')" class="help is-danger">{{ errors.first('Name on Card') }}</span>
    </p>
  </div>
  <div class="col-md-6">
    <label class="label">Card Number</label>
    <p class="control has-icon has-icon-right">
      <masked-input name="CC Card Number" v-model="ccInfo.CCNumber" v-validate="'required'" mask="1111-1111-1111-1111" :class="{'form-control input': true, 'is-danger': errors.has('CC Card Number') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('CC Card Number')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('CC Card Number')" class="help is-danger">{{ errors.first('CC Card Number') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label class="label">Expiration Date (MM-YY)</label>
    <p class="control has-icon has-icon-right">
      <masked-input name="Expiration Date" v-model="ccInfo.CCExpiration" v-validate="'required'" mask="11-11" :class="{'form-control input': true, 'is-danger': errors.has('Expiration Date') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Expiration Date')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Expiration Date')" class="help is-danger">{{ errors.first('Expiration Date') }}</span>
    </p>
  </div>
  <div class="col-md-6">
    <label class="label">CVV Code</label>
    <p class="control has-icon has-icon-right">
      <b-input name="CVV" v-model="ccInfo.CVVCode" v-validate="'required|numeric|min:3|max:4'" :class="{'input': true, 'is-danger': errors.has('printname') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('CVV')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('CVV')" class="help is-danger">{{ errors.first('CVV') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <p>Card holder's billing address</p>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label class="label">Street</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Street Billing Address" v-model="ccInfo.BillingAddress.Street" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Street Billing Address') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Street Billing Address')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Street Billing Address')" class="help is-danger">{{ errors.first('Street Billing Address') }}</span>
    </p>
  </div>
  <div class="col-md-6">
    <label class="label">City</label>
    <p class="control has-icon has-icon-right">
      <b-input name="City Billing Address" v-model="ccInfo.BillingAddress.City" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('City Billing Address') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('City Billing Address')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('City Billing Address')" class="help is-danger">{{ errors.first('City Billing Address') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label class="label">State</label>
    <p class="control has-icon has-icon-right">
      <b-input name="State Billing" v-model="ccInfo.BillingAddress.State" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('State Billing') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('State Billing')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('State Billing')" class="help is-danger">{{ errors.first('State Billing') }}</span>
    </p>
  </div>
  <div class="col-md-6">
    <label class="label">Zip</label>
    <p class="control has-icon has-icon-right">
      <b-input name="ZIP" v-model="ccInfo.BillingAddress.ZipCode" v-validate="'required|numeric|min:3|max:5'" :class="{'input': true, 'is-danger': errors.has('ZIP') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('ZIP')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('ZIP')" class="help is-danger">{{ errors.first('ZIP') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <h4 class="achHeading">AUTHORIZATION</h4>
    <p class="achParagraph">By typing your name below, you are signing this Agreement electronically. You agree your electronic signature is the legal equivalent to your manual/handwritten signature on this Agreement. By electronically signing using any device, means or action, you consent to the legally binding terms and conditions of this Agreement. You further agree that your signature on this document (hereafter referred to as your "E-Signature") is as valid as if you signed the document in writing. You also agree that no certification authority or other third party verification is necessary to validate your E-Signature, and that the lack of such certification or third party verification will not in any way affect the enforceability of your E-Signature or any resulting agreement between you and Pawnee Leasing Corporation. You are also confirming that you are the authorized representative of the Lessee/Borrower to enter into this Agreement. You further agree that your E- Signature constitutes your agreement to be bound by the terms and conditions of these Disclosures and Agreement as they exist on the date of your E- Signature on this form. Pawnee Leasing Corporation will not make changes to the existing Credit Card information if the new information you provide is invalid or incomplete. The information will be discarded and a new request may need to be made with the necessary information to in order to update the company’s records.</p>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label class="label">Authorized Signer:</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Authorized Signer" v-model="ccInfo.AuthorizedSigner" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Authorized Signer') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Authorized Signer')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Authorized Signer')" class="help is-danger">{{ errors.first('Authorized Signer') }}</span>
    </p>
  </div>
  <div class="col-md-6">
    <label class="label">Cardholder's Phone Number:</label>
    <p class="control has-icon has-icon-right">
      <masked-input name="Cardholder Phone Number" v-model="ccInfo.AuthorizedSignerPhoneNumber" v-validate="'required'" mask="(111) 111-1111" :class="{'form-control input': true, 'is-danger': errors.has('Cardholder Phone Number') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Cardholder Phone Number')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Cardholder Phone Number')" class="help is-danger">{{ errors.first('Cardholder Phone Number') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label class="label">Title</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Title" v-model="ccInfo.Title" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Title') }" type="text"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Title')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Title')" class="help is-danger">{{ errors.first('Title') }}</span>
    </p>
  </div>
  <div class="col-md-6">
    <label class="label">Date</label>
    <p class="control has-icon has-icon-right">
      <b-input name="Date" v-model="ccInfo.Date" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Date') }" type="date"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Date')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Date')" class="help is-danger">{{ errors.first('Date') }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col">
    <p class="achParagraph">I understand and agree there will be a recurring charge to my credit card each month and for the amounts, I agreed to pay under the contract, including without limitation all contract payments, any purchase option, late fees, taxes, insurance charges, reimbursements, and other amounts due under the contract. If for any reason the payment is declined, I shall pay Lessor or Lender a $30.00 fee. This authority is to remain in full force and effect until Pawnee Leasing Corporation has received written notification from me (us) of its termination in such time and in such manner as to afford Pawnee Leasing Corporation a reasonable opportunity to act on it.</p>
  </div>
</div>
<div class="row">
  <div class="col">
    <p class="control">
      <button class="btn btn-primary" type="submit">Submit</button>
    </p>
  </div>
</div>
</b-form>
</div>
<div class="container fluid" v-else-if="user.authenticated && message">
    <div class='row'>
      <div class='col' >
        <h4 :class='sentClass'>{{message}}</h4>
      </div>
    </div>
</div>
<div class="row" v-else>
  <div class="col text-center">
  <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
  </div>
</div>
</div>
</template>

<script>
import auth from './auth'
import axios from 'axios'
import moment from 'moment'
import MaskedInput from 'vue-masked-input'
export default {
  name: 'modalCC',
  components: {
    MaskedInput
  },
  props: {
    parentData: {
      type: Number
    },
    modalccid: {
      type: String
    }
  },
  data: function () {
    return {
      checkupload: '',
      message: null,
      ccInfo: {
        BillingAddress: {},
        Date: ''
      },
      user: auth.user,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.ccInfo.Date) {
            this.ccInfo.Date = moment(this.ccInfo.Date).format('YYYY-MM-DD')
          }
          // Data is valid, so we can submit the form.
          let uri = this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/billingaccounts/CCAuth'
          axios.post(uri, this.ccInfo, {headers: auth.getAuthHeader()}).then((response) => {
            this.ccInfo.Date = moment(this.ccInfo.Date).format('MM-DD-YYYY')
            this.sentClass = 'text-success'
            this.message = 'Thank you for submitting your CC information. We will process it as quickly as possible.'
            this.ccInfo = {}
            this.timer = setTimeout(() => {
              this.$root.$emit('bv::hide::modal', this.modalccid)
              this.message = null
            }, 10000)
          }).catch(() => {
            this.sentClass = 'text-danger'
            this.message = 'Something went wrong please try again later.'
            this.timer = setTimeout(() => { this.message = '' }, 10000)
          })
        }
      })
    }
  }
}
</script>

<style>
.achParagraph {font-size: 1em;}
.achParagraph span {color:red; font-weight: bold;}
.achHeading {background: #000000; color:#ffffff; padding:5px;}
.is-danger {color:red;}
.input {width:100%;}
.fileUploadText {font-size:0.8em; margin:0; padding: 0;}
</style>



// WEBPACK FOOTER //
// src/modalCC.vue